"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BalanceWrapper = exports.BalanceTitle = exports.BalanceLine = exports.BalanceItem = exports.BalanceDescription = void 0;
var _mui = require("@ori-ui/mui");
const BalanceWrapper = exports.BalanceWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        borderBottom: "1px solid ".concat(theme.palette.grey[200]),
        paddingBottom: theme.spacing(3),
        marginBottom: theme.spacing(3),
        '&:last-child': {
            borderBottom: 'none',
            paddingBottom: 0,
            marginBottom: 0
        }
    };
});
const BalanceTitle = exports.BalanceTitle = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(2)
    };
});
const BalanceLine = exports.BalanceLine = (0, _mui.styled)('div')({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
});
const BalanceItem = exports.BalanceItem = (0, _mui.styled)(_mui.Typography)({
    fontWeight: 'bold'
});
const BalanceDescription = exports.BalanceDescription = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.spacing(1),
        padding: theme.spacing(3),
        marginTop: theme.spacing(3),
        fontSize: theme.typography.caption.fontSize
    };
});
